import React from "react";
import "../css/home-page.css";
import "../css/media-query.css";
import { Link } from "react-router-dom";


import leaderImg from "../assets/symbol.png";

// 👉 Add your 3 card images in assets folder
import card1 from "../assets/card1.jpg";
import card2 from "../assets/card2.jpg";
import card3 from "../assets/card3.jpg";

function HomePage() {
  return (
    <div className="container">


      <main className="body">
        <h2>திற்பரப்பு பேரூராட்சி – தமிழக வெற்றிக் கழகம்</h2>

        {/* Leader Image */}
        <img src={leaderImg} alt="TVK Leader" className="home-image" />

        {/* Sub Heading */}
        <h3 className="sub-heading">
          நமது வெற்றிச் சின்னம் விசில்
        </h3>

        {/* ✅ Three Image Cards */}
        <div className="card-section">

          <Link to="/gallery" className="card">
            <img src={card1} alt="Service 1" />
          </Link>

          <Link to="/gallery2" className="card">
            <img src={card2} alt="Service 2" />
          </Link>

          <Link to="/gallery3" className="card">
            <img src={card3} alt="Service 3" />
          </Link>

        </div>


        {/* ✅ Heading below cards */}
        <h3 className="cards-heading">
          மக்கள் சேவையே எங்கள் முதன்மை
        </h3>

        {/* Paragraph */}
        <p>
          
தமிழக வெற்றிக் கழகத்தின் (TVK) நிறுவனர் தளபதி விஜய் அவர்கள் சமூக நீதி, அரசியல் மாற்றம் மற்றும் தமிழக மக்கள் முன்னேற்றம் குறித்த ஆழ்ந்த நம்பிக்கையுடன் செயல்படும் ஒரு துருவ நட்சத்திரம். மக்களுக்கான சேவையில் அவருக்கு உள்ள அனுபவமும், ஊழல் இல்லாத, நவீன தமிழ்நாடு உருவாக்கும் முயற்சிகளும் அவருக்கு தமிழகத்தின் பல்வேறு தரப்பில் உள்ள மக்களின் மதிப்பு மற்றும் மரியாதையை பெற்றுத்தந்துள்ளன. தளபதி விஜய் அவர்களின் தலைமை சிறப்பம்சம் என்பது தாழ்த்தப்பட்ட மக்களை அதிகாரப்படுத்தவும், அனைவருக்கும் சமநிலை வாய்ந்த வளர்ச்சியை முன்னெடுப்பதிலும் உறுதியாக செயல்படுவதாகும். பொருளாதார சமநிலை, தரமான கல்வி, மற்றும் சீரான வேலைவாய்ப்புகளுக்கான வலியுறுத்தலுக்காக அவர் தொடர்ந்து குரல் கொடுத்துவருகிறார்.  </p><p> அவரது வழிகாட்டுதலின் கீழ், தமிழக வெற்றிக் கழகம் ஒரு வலுவான இயக்கமாக மாறி, அடிப்படை மட்டத்தில் மக்களை ஒன்றிணைக்கும் மற்றும் பொது மக்களின் தேவைகளை நிறைவேற்றும் கொள்கைகளை முன்னெடுத்து செயல்பட்டு வருகிறது.
 </p><p>
அவருடைய நேர்மை, வெளிப்படை தன்மை மற்றும் ஒற்றுமையான நடவடிக்கைகளின் மீது உள்ள நம்பிக்கை, தளபதி விஜய் அவர்களை எதிர்கால தலைமுறைக்கு முன்னோடியாக மாற்றியுள்ளது. அவருடைய தமிழ்நாடு கனவு என்பது அனைத்து மக்களும் முன்னேறக் கூடிய, நன்மை அடையக் கூடிய, ஒற்றுமையான, வளர்ச்சியடையும் நவீன தமிழ்நாடு உருவாக வேண்டும் என்பதே ஆகும்.
 </p><p>
தமிழக வெற்றிக் கழகம் மூலம், அவர் தமிழ்நாட்டின் அரசியல் களத்தை மாற்றும் நோக்கத்தில், நேர்மை, முன்னேற்றம், சமூக நீதி ஆகியவற்றை மையமாகக் கொண்டு செயல்படுகிறார். அவருடைய தலைமை, ஒவ்வொரு தமிழர் மனதிலும் எதிர்காலத்தை மாற்றும்வகையில் நம்பிக்கையை விதைத்துக் கொண்டிருக்கிறது.
        </p>
      </main>


    </div>
  );
}

export default HomePage;
